import { configureAbly } from '@ably-labs/react-hooks';
import { Route, Routes, useSearchParams } from 'react-router-dom';
import { ActivitiesList } from './ActivitiesList';
import Messages from './Messages';
import { Profile } from './Profile';
import { Head } from '~/components/shared/Head';
import { useTranslation } from 'react-i18next';
import { UserActivity } from './components/UserActivity';
import { MessagesHeader } from './components/MessagesHeader';
import { useMediaQuery } from '@uidotdev/usehooks';

configureAbly({
  authUrl: `${import.meta.env.VITE_API_URL}/realtime/auth`,
});

export default function ChatDashboard() {
  const [t] = useTranslation('locale');
  const [searchParams] = useSearchParams();
  const isSmallDevice = useMediaQuery('only screen and (max-width : 1024px)');
  const currentConversationId = searchParams.get('conversationId');

  return (
    <div className="flex h-full w-full flex-row">
      <Head title={t('navigation.chat')} />
      <ActivitiesList />
      <Routes>
        <Route
          path=":personId/*"
          element={
            <>
              <div className="flex w-full flex-col">
                <MessagesHeader isSmallDevice={isSmallDevice} />
                {currentConversationId ? <Messages /> : <UserActivity />}
              </div>
              <Profile />
            </>
          }
        />
      </Routes>
    </div>
  );
}
